console.log('aos script engaged');

AOS.init();
let scrollRef = 0;
window.addEventListener('scroll', function () {
	// increase value up to 10, then refresh AOS
	scrollRef <= 10 ? scrollRef++ : AOS.refresh();
});
